import { Flex, Spinner, Text } from "@radix-ui/themes";
import { useI18n } from "@/i18n";

export function LoadingState() {
  const { t } = useI18n();
  return (
    <Flex direction="column" align="center" justify="center" gap="3" className="rk-state-panel">
      <Spinner size="3" />
      <Text size="2" color="gray">
        {t("state.loading")}
      </Text>
    </Flex>
  );
}
